export default {
  init() {

    // news story filtering
    
    const url = new URL(window.location.href);
    const categoryParam = url.pathname.match(/\/news\/category\/(?<slug>.*)\//)?.groups?.slug ?? false;
    const activeClasses = 'border-solarFlare';
    const inactiveClasses = 'border-transparent';
    const newsItems = $('[data-categories]');
    const newsFilters = $('[data-category]');
    const isArchivePage  = !!categoryParam;
    const isSingleArticle  = $('body').hasClass('single');

    // update filters when moving through history

    $(window).on('popstate', e => {
      filterNews(categoryParam);
    });
    
    const filterNews = (cat = 'all') => {

      // show/hide news posts

      newsItems
        .show()
        .each((index, el) => {
          const categories = $(el).data('categories').split(',');
          if ( cat !== 'all' && !categories.includes(cat ) ) {
            $(el).hide();
          }
        });
      
      // set active/inactive filter links

      newsFilters
        .removeClass(activeClasses)
        .addClass(inactiveClasses)
        .filter(`[data-category=${cat}]`)
        .addClass(activeClasses)
        .removeClass(inactiveClasses);       
    }

    // if not an archive page and not single news article, override filter click behaviour

    if ( !isArchivePage && !isSingleArticle ) {

      newsFilters
        .on('click keypress', e => {
          e.preventDefault();
          const category = $(e.currentTarget).data('category')
          history.pushState(null, null, `/news/category/${category}`);
          filterNews(category);
        });

      filterNews();

    }
    else {
      // initialize filters      
      filterNews(categoryParam);
    }

    // news story searching

    const searchForm = $('#search-form');

    // if not an archive page and not single news article, override form submit behaviour

    if ( !isArchivePage && !isSingleArticle ) {

      searchForm.on('submit', () => {
        return false;
      });

      searchForm
        .find('input[name=s]')
        .on('keyup', e => {
          const query = $(e.currentTarget).val();
          if ( query ) {
            newsItems
              .hide()
              .each((index, el) => {
                if ( query.length > 2 && $(el).text().toLowerCase().includes( query.toLowerCase() ) ) {
                  $(el).show();
                }
              })
          }
        })

    } else {

      searchForm.on('submit', () => {
        const query = searchForm.find('input[name=s]').val();

        if ( !query ) {
          return false;
        }

      }); 
           
    }

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
}
